import styled from 'styled-components';

import { StrongText } from '@dreryk/react-components';

export const StyledStrongText = styled(StrongText)`
   text-align: center;
`;

StyledStrongText.displayName = 'StyledStrongText';
